import React from "react";
import {Box, Stack, Tooltip, Typography} from "@mui/material";
import {grey, red} from "@mui/material/colors";
import {
    PhoneMissed,
    RadioButtonUnchecked,
    ForumOutlined, DoneOutline
} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";

const StatBlock = ({icon: Icon, iconColor, count, label, onClick}) => (
    <Stack
        onClick={onClick}
        alignItems="center"
        justifyContent="center"
        sx={{
            bgcolor: grey[50],
            borderRadius: 2,
            py: 1,
            px: 1,
            flex: 1,
            cursor: onClick ? "pointer" : "default",
            transition: "transform 0.15s ease",
            "&:hover": onClick ? {transform: "scale(1.03)"} : {},
        }}
    >
        <Icon sx={{fontSize: 22, color: iconColor}}/>
        <Typography sx={{fontSize: 17, fontWeight: 500, mt: 1, mb: 0.25, color: grey[900]}}>
            {count}
        </Typography>
        <Typography sx={{fontSize: 11, color: grey[500]}}>
            {label}
        </Typography>
    </Stack>
);

export const ConversationStatusGauge = ({project, resolved, unresolved, missedCalls, tagUsage}) => {
    const isVoice = (project?.settings?.projectType || "VOICE_BOT") === "VOICE_BOT";
    const unresolvedExcludingMissed = unresolved - missedCalls;
    const navigate = useNavigate();
    // this needs to be endpoint fetch (backend)
    const startedToday = tagUsage?.main_menu || 0;

    return (
        <Stack
            direction="column"
            gap={0}
            sx={{borderRadius: 3, p: 1.5}}
            className={"border-shadow"}
        >
            <Typography variant={"body1"} color={grey[500]} sx={{mb: 1}}>
                CONVERSATION STATUS
            </Typography>

            <Stack direction="row" gap={1.5}>
                {isVoice && (
                    <Tooltip title={"Show Missed Calls"}>
                        <StatBlock
                            icon={PhoneMissed}
                            iconColor={missedCalls ? red[500] : grey[400]}
                            count={missedCalls}
                            label="Missed calls"
                            onClick={() => navigate(`/project/${project?.id}/supervision?status=${missedCalls ? "MISSED_CALL" : ""}`)}
                        />
                    </Tooltip>
                )}
                {!isVoice && (
                    <StatBlock
                        icon={ForumOutlined}
                        iconColor={grey[700]}
                        count={startedToday}
                        label="Total"
                    />
                )}
                <StatBlock
                    icon={DoneOutline}
                    iconColor={grey[900]}
                    count={resolved}
                    label="Resolved"
                />
                <StatBlock
                    icon={RadioButtonUnchecked}
                    iconColor={grey[400]}
                    count={unresolvedExcludingMissed}
                    label="Unresolved"
                />
            </Stack>
        </Stack>
    );
};